<div>

  <app-app-dashboard-navigation></app-app-dashboard-navigation>

  <div class="dash-section m-5 p-3 bg-white">
    <div class="m-4">
      <div class="col font-weight-bold text-black-50 ">
        <div class="h-100 d-flex align-items-center ">
        <h3 class="page-subtitle">
        Diagnosis/{{ type }}
        </h3>
        </div>
      </div>
      <!-- <div class="col" (click)="showFilter = !showFilter">
        <button class="btn float-right btn-md text-white px-3 filter-orange-bg mt-n4" id="toggleMessage">
          <span *ngIf="!showFilter">Show filter<i class="fas fa-chevron-down"></i></span>
          <span *ngIf="showFilter">Hide filter<i class="fas fa-chevron-up"></i></span>
        </button>
      </div>
      <hr />
    </div>

    <div class="row m-4 border-bottom filter-panel" *ngIf="showFilter">
      <div class="col-5">
        <p class="font-weight-bold">Crop</p>
        <select class="w-100 custom-select">
          <option>All</option>
        </select>
      </div>
      <div class="col-5" *ngIf="type === 'Diseases'">
        <p class="font-weight-bold">Disease</p>
        <select class="w-100 custom-select">
          <option>All</option>
        </select>
      </div>

      <div class="col-2 buttons" align="right">
        <button class="btn btn-md filter-teal-bg text-white apply">
          Apply
        </button>
        <button class="btn btn-md bg-dark disabled text-white clear">
          Clear
        </button>
      </div> -->
    </div>
  </div>

  <app-post-diagnosis-modal [category]="category" (reloadDiagnosisEvent)="refreshDiagnosisList()">
  </app-post-diagnosis-modal>

  <div class="dash-section m-5 bg-white">
    <div class="col  ">
      <div class="row dash-section px-5 ">
        <div class="col p-2">
          <h3 class="mt-4 py-3 float-left">Diagnosis/{{ type }}</h3>
          <button class="float-right btn background text-white my-3 mt-5 mr-2" data-toggle="modal"
            data-target="#diagnosisModal">
            <i class="fas fa-plus mr-2"></i>Add Diagnosis Information
          </button>
        </div>
      </div>
      <div class="row dash-section px-5">
        <div class="container">
          <p-table #diagnosisT
          [value]="data"
          [paginator]="true"
          [rows]="10"
          [loading]="loading"
          [rowsPerPageOptions]="[10,20,30,40,50]"
          class="table table-striped table-hover"
          >
          <!-- <table class="table table-striped table-hover"> -->
            <!-- <thead class="table_head"> -->
              <ng-template pTemplate="caption"  >
                <div class="row" style="width: 100%;">
                  <div class="col-sm-4 ui-g ui-fluid">
                    <!-- <i class="pi pi-search" style="margin:4px 4px 0 0"></i> -->
                    <div class="ui-g-12 ui-md-12">
                      <h6>Crop</h6>
                      <p-multiSelect
                      id="selectcrop"
                      #selectcrop="ngModel"
                      [(ngModel)]="selectedCrops"
                      [options]="selectCrop"
                      defaultLabel="All"
                      (onChange)="diagnosisT.filter($event.value, 'crop', 'in')">
                      </p-multiSelect>
                    </div>


                  </div>
                  <div class="col-sm-4 ui-g ui-fluid">
                    <!-- <i class="pi pi-search" style="margin:4px 4px 0 0"></i> -->
                    <div class="ui-g-12 ui-md-12">
                      <h6>{{ type }}</h6>
                      <p-multiSelect
                      id="nameselect"
                      #nameselect="ngModel"
                      [(ngModel)]="selectedName"
                      [options]="namesToSelect"
                      defaultLabel="All"
                      (onChange)="diagnosisT.filter($event.value, 'name', 'in')">
                      </p-multiSelect>
                    </div>


                  </div>
                  <div class="col-sm-4">
                    <p>&nbsp;</p>
                    <button
                    (click)="Clear(diagnosisT)"

                    style="float: right;"
                    class="btn btn-md bg-dark disabled text-white clear"
                    >
                    Clear Filters
                    </button>
                  </div>

                </div>
            </ng-template>
            <ng-template pTemplate="header" class="table_head">
              <tr>
                <th scope="col" style="width: 40px; background-color: rgb(89, 170, 233);color: white;">#</th>
                <th scope="col" *ngIf="type === 'Diseases'" style="background-color: rgb(89, 170, 233);color: white;">
                  Disease Name
                </th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;" *ngIf="type === 'Pests'">Pest Name</th>

                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Image</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Cause</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Crop</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Prevention&Control</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;" *ngIf="type === 'Diseases'">Symptoms</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;" *ngIf="type === 'Pests'">Effects</th>

                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
            <!-- </thead>
            <tbody *ngIf="!loading && data; else spinnerDiv"> -->
              <tr>
               <!-- *ngFor="
                                      let row of data.data
                                        | paginate: { itemsPerPage: count, currentPage: page };
                                        let i = index
                                    "> -->
                <td> {{ data.indexOf(row)+1 }}</td>
                <td>{{ row.name }}</td>
                <td><img src='{{ "https://storage.googleapis.com/ezyagric-media" + row.photo_url }}' width="80" height="80" alt="{{category}} image"
                    *ngIf="row.photo_url" />
                  {{ !row.photo_url ? 'N/A' : '' }}</td>
                <td>{{ row.cause }}</td>
                <td>{{ row.crop }}</td>
                <td [innerHTML]="row.control | truncateText:5" class="text"></td>
                <td [innerHTML]="row.explanation | truncateText:5" class="text"></td>

                <td>
                  <div class="dropdown">
                    <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="clearMessage()">
                      ACTION
                    </button>
                    <div class="dropdown-menu options" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" data-toggle="modal" data-target="#viewModal"
                        (click)="setDiagnosisView(row)">View
                      </a>
                      <a class="dropdown-item" data-toggle="modal" data-target="#editModal"
                        (click)="setDiagnosisAction(row, 'Edit', 'editModal')">
                        Edit
                      </a>
                      <a class="dropdown-item" data-toggle="modal" data-target="#deleteModal"
                        (click)="setSingleDiagnosisView(row)">Delete</a>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
            <!-- </tbody> -->
            <ng-template #spinnerDiv>
              <tbody>
                <tr>
                  <td colspan="8">
                    <div class="spinner d-flex">
                      <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </ng-template>
          <!-- </table> -->
          <!-- <nav aria-label="Diagnosis pagination table">
            <pagination-controls (pageChange)="page = $event"></pagination-controls>
          </nav> -->
        </div>
      </div>
    </div>
    <div class="m-4">&nbsp;</div>
  </div>
  <div class="m-4">&nbsp;</div>
  <!-- View diagnosis modal -->
  <div class="modal fade" id="viewModal" tabindex="-1" role="dialog" aria-labelledby="viewDiagnosisModalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 60%;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-color" id="viewDiagnosisModalTitle">{{ category | titlecase }} Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container-fluid" *ngIf="diagnosisViewData">
            <div class="row">
              <div class="col-4">
                <div>
                  <img src='{{ "https://storage.googleapis.com/ezyagric-media" + diagnosisViewData.photo_url }}' alt="diagnosisViewData.activity" class="img-fluid"
                    *ngIf="diagnosisViewData.photo_url" />
                </div>
              </div>
              <div class="col-8">
                <div>
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <th scope="row">{{ category | titlecase }} Name:</th>
                        <td>{{ diagnosisViewData.name }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Cause:</th>
                        <td>{{ diagnosisViewData.cause }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Crop:</th>
                        <td>{{ diagnosisViewData.crop }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Prevention:</th>
                        <td [innerHTML]="diagnosisViewData.control"></td>
                      </tr>
                      <tr>
                        <th scope="row">Symptoms:</th>
                        <td [innerHTML]="diagnosisViewData.explanation"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete modal -->
  <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteDiagnosisModal"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" *ngIf="diagnosisDeleteData">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteDiagnosisModal">Delete {{ category | titlecase }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body" *ngIf="!deleteDiagnosisloading && !message">
          <span class="text-center" *ngIf="message">{{ message }}</span>
          Are you sure you want to delete <span class="font-weight-bold">{{ diagnosisDeleteData.name }}</span>
        </div>
        <div class="modal-body" *ngIf="message">
          <span class="text-center">{{ message }}</span>
        </div>
        <div class="spinner d-flex" *ngIf="deleteDiagnosisloading">
          <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
        </div>
        <div class="modal-footer" *ngIf="!deleteDiagnosisloading">
          <button type="button" class="btn btn-danger" (click)="deleteDiagnosis(diagnosisDeleteData.id)"
            *ngIf="!message">Delete {{ category | titlecase }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" *ngIf="!message">Close</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" *ngIf="message">Ok
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-edit-diagnosis-modal [modalId]="editModal" [diagnosisInput]="diagnosisData.input" [diagnosisId]="diagnosisData.id" [diagnosisData]="diagnosisData" [category]="category"
    [action]="diagnosisAction" *ngIf="diagnosisData" (closeDiagnosisModalEvent)="closeDiagnosisModal()"
    (refreshDiagnosisEvent)="refreshDiagnosisList()">
  </app-edit-diagnosis-modal>
</div>
